'use client';

var headings = ["h1", "h2", "h3", "h4", "h5", "h6"];
function lineHeightResolver(value, theme) {
  if (typeof value === "string" && value in theme.lineHeights) {
    return "var(--mantine-line-height-".concat(value, ")");
  }
  if (typeof value === "string" && headings.includes(value)) {
    return "var(--mantine-".concat(value, "-line-height)");
  }
  return value;
}
export { lineHeightResolver };